<template>
  <div id="Home">
    <Header :title="$t('Header.ClassRoom')" logoutPath="/login" />
    <Menu />
    <div class="pnlBEContent pnlHome scrollBar">
      <label class="lblHomeTitle">{{ $t("UserHome.ClassManagement") }}</label>
      <div class="btnClassManager" @click="BackClassSetting">
        <img
          class="imgClassManager"
          src="@/assets/img/home/icon_class_b2.png"
        />
        <label class="txtClassManager">{{ $t("UserHome.ClassSetting") }}</label>
        <img
          class="imgClickHint"
          src="@/assets/img/home/icon_arrow_Hover.png"
        />
      </div>
      <hr class="hrHome" />
      <label class="lblHomeTitle">{{ $t("UserHome.ClassRoom") }}</label>
      <div class="pnlItemsScroll">
        <div class="pnlAPPItem" v-if="AppShow('Teaching Cool')">
          <img class="imgSurreal" src="@/assets/img/menu/icon_SE_Hover.png" />
          <label class="lblAppName">{{ $t("UserHome.TeachingCool") }}</label>
          <img class="imgAPP" src="@/assets/img/home/img_VRdeucation.png" />
          <div class="pnlHoverTools">
            <img
              class="imgTools"
              src="@/assets/img/menu/icon_serch_Hover.png"
              @click="BackSCR_Model"
            />
            <img
              class="imgTools"
              src="@/assets/img/menu/icon_heart_Hover.png"
              @click="BackSCR_Favorite"
            />
            <img
              class="imgTools"
              src="@/assets/img/menu/icon_Custom_Hover.png"
              @click="BackSCR_Customize"
            />
          </div>
        </div>

        <div class="pnlAPPItem" v-if="AppShow('Spelling Gladiator')">
          <img class="imgSurreal" src="@/assets/img/menu/icon_SE_Hover.png" />
          <label class="lblAppName">{{ $t("UserHome.SESG") }}</label>
          <img class="imgAPP" src="@/assets/img/home/img_gladiator.png" />
          <div class="pnlHoverTools">
            <img
              class="imgTools"
              src="@/assets/img/menu/icon_Custom_Hover.png"
              @click="BackSESG_Customize"
            />
            <img
              class="imgTools"
              src="@/assets/img/menu/icon_clock_Hover.png"
              @click="BackSESG_Record"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
export default {
  mounted() {
    this.$gtag.event("user_id", {
      event_category: "test",
      event_label: this.$store.state.Profile.Name,
      value: 1,
    });
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    BackClassSetting() {
      if (this.nowTab != "classsetting") {
        this.$router.push({ path: "/Setting/classsetting" });
        this.nowTab = "classsetting";
      }
    },
    BackSCR_Model() {
      if (this.nowTab != "models") {
        this.$router.push({ path: "/SurrealClassRoom/models" });
        this.nowTab = "models";
      }
    },
    BackSCR_Favorite() {
      if (this.nowTab != "favorite") {
        this.$router.push({ path: "/SurrealClassRoom/favorite" });
        this.nowTab = "favorite";
      }
    },
    BackSCR_Customize() {
      if (this.nowTab != "customize") {
        this.$router.push({ path: "/SurrealClassRoom/customize" });
        this.nowTab = "customize";
      }
    },
    BackSESG_Customize() {
      if (this.nowTab != "sgcustomize") {
        this.$router.push({ path: "/SpellingGladiator/customize" });
        this.nowTab = "sgcustomize";
      }
    },
    BackSESG_Record() {
      if (this.nowTab != "sgrecord") {
        this.$router.push({ path: "/SpellingGladiator/record" });
        this.nowTab = "sgrecord";
      }
    },
  },
  components: {
    Header,
    Menu,
  },
};
</script>